<div class="table-responsive" *ngIf="_isAnnual && !noDataAnnual">
   <table class="table">
      <thead>
         <tr>
            <th width="320">Currency: USD</th>
            <th class="text-right" *ngFor="let year of years" style="text-align: right">
               {{ year }}
            </th>
         </tr>
      </thead>
      <tbody>
         <ng-container *ngFor="let item of processedData">
            <ng-container *ngTemplateOutlet="
                  recursiveRow;
                  context: { $implicit: item, level: 0 }
               ">
            </ng-container>
         </ng-container>
      </tbody>
   </table>
</div>

<!-- Recursive template for annual data -->
<ng-template #recursiveRow let-item let-level="level">
   <tr [ngClass]="{
         'parent-row': item.children,
         'level-0': level === 0,
         'level-1': level === 1,
         'level-2': level === 2
      }" (click)="toggleRow(item)">
      <td [title]="item.label | keyToLabel" class="truncated-label">
         <div class="d-flex align-items-center gap-1 justify-content-between" [style.padding-left.rem]="level * 1.5">
            <div class="d-flex align-items-center gap-1">
               <a *ngIf="item.children" class="btn btn-link p-0 mr-2"
                  (click)="toggleRow(item); $event.stopPropagation()">
                  <i class="fas chevron-icon" [ngClass]="{
                     'fa-chevron-down': expandedRows[item.label],
                     'fa-chevron-right': !expandedRows[item.label],
                     'parent-chevron': level === 0,
                     'child-chevron': level === 1,
                     'grandchild-chevron': level === 2
                  }">
                  </i>
               </a>

               <span [class.font-weight-bold]="level === 0">{{
                  item.label | keyToLabel
                  }}</span>
            </div>
            <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
               src="../../../../../../assets/icons/icon-info.svg" /> -->
         </div>
      </td>
      <td *ngFor="let year of years" class="text-right" style="text-align: right" (click)="$event.stopPropagation()">
         {{ formatValue(item.data[year]) }}
      </td>
   </tr>

   <ng-container *ngIf="item.children && expandedRows[item.label]">
      <ng-container *ngFor="let child of item.children">
         <ng-container *ngTemplateOutlet="
               recursiveRow;
               context: { $implicit: child, level: level + 1 }
            ">
         </ng-container>
      </ng-container>
   </ng-container>
</ng-template>

<div *ngIf="noDataAnnual && _isAnnual" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Annual Data Available!</p>
</div>

<!-- Quarterly Data Table -->
<div class="table-responsive" *ngIf="!_isAnnual && !noDataQuarterly">
   <table class="table">
      <thead>
         <tr>
            <th width="320">Currency: USD</th>
            <th class="text-right" *ngFor="let quarter of quarters" style="text-align: right">
               {{ quarter }}
            </th>
         </tr>
      </thead>
      <tbody>
         <ng-container *ngFor="let item of processedQuarterlyData">
            <ng-container *ngTemplateOutlet="
                  recursiveTable;
                  context: { $implicit: item, level: 0 }
               ">
            </ng-container>
         </ng-container>
      </tbody>
   </table>
</div>

<!-- Recursive template for quarterly data -->
<ng-template #recursiveTable let-item let-level="level">
   <ng-container *ngIf="hasData(item.data)">
      <tr [ngClass]="{
            'parent-row': item.children?.length,
            'level-0': level === 0,
            'level-1': level === 1,
            'level-2': level === 2
         }" (click)="toggleRow2(item)">
         <td [title]="item.label | keyToLabel" class="truncated-label">
            <div class="d-flex align-items-center gap-1 justify-content-between" [style.padding-left.rem]="level * 1.5">
               <div class="d-flex align-items-center gap-1">
                  <a *ngIf="item.children?.length" class="btn btn-link p-0 mr-2"
                     (click)="toggleRow2(item); $event.stopPropagation()">
                     <i class="fas chevron-icon" [ngClass]="{
                        'fa-chevron-down': expandedRows2[item.label],
                        'fa-chevron-right': !expandedRows2[item.label],
                        'parent-chevron': level === 0,
                        'child-chevron': level === 1,
                        'grandchild-chevron': level === 2
                     }">
                     </i>
                  </a>
                  <span>{{ item.label | keyToLabel }}</span>
               </div>
               <!-- <img ngbTooltip="Table Content Tooltip" placement="auto"
                  src="../../../../../../assets/icons/icon-info.svg" /> -->
            </div>
         </td>
         <td *ngFor="let quarter of quarters2" class="text-right" style="text-align: right"
            (click)="$event.stopPropagation()">
            {{ getFormattedValue(item?.data, quarter) }}
         </td>
      </tr>

      <ng-container *ngIf="expandedRows2[item.label]">
         <ng-container *ngFor="let child of item.children">
            <ng-container *ngTemplateOutlet="
                  recursiveTable;
                  context: { $implicit: child, level: level + 1 }
               ">
            </ng-container>
         </ng-container>
      </ng-container>
   </ng-container>
</ng-template>

<div *ngIf="noDataQuarterly && !_isAnnual" class="no-data-container">
   <img src="assets/images/financials/no-data-image.svg" alt="No data" />
   <p>No Quarterly Data Available!</p>
</div>
